import { Injectable } from "@angular/core";
import { PlanNPricingService } from "@app/modules/admin/providers/plan-n-pricing/plan-n-pricing.service";

@Injectable({
    providedIn: 'root'
})
export class PaymentHandler {
    
    constructor() {}

    onInit() {}
}
